<template>
  <div class="body">
    <HeaderComp></HeaderComp>

    <main class="home-main">
      <section class="hero" aria-labelledby="home-title">
        <img class="hero-photo" src="/pic1.jpeg" alt="ML Rehvid rehvitöökoda" />
        <div class="hero-overlay" aria-hidden="true"></div>
        <div class="hero-content">
          <h1 id="home-title" class="hero-title">
            ML Rehvid – Sinu rehvipartner Pärnus
          </h1>
          <p class="hero-subtitle">
            Kiire teenindus, aus hind, professionaalne tulemus.
          </p>
        </div>
      </section>

      <section class="service-band">
        <div class="service-inner">
          <ul class="slogan-list">
            <li>Uued ja kasutatud rehvid</li>
            <li>Rehvide vahetus, montaaz ja tasakaalustamine</li>
            <li>Velgede remont ja sirgendus</li>
            <li>Hooajaline rehvide hoiustamine</li>
            <li>Rasketehnika rehvitööd kokkuleppel</li>
          </ul>
        </div>
      </section>
    </main>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComp,
    FooterComp,
  },
};
</script>

<style scoped>
.body {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #151217;
  box-sizing: border-box;
  overflow-x: hidden;
}

.home-main {
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hero {
  width: 100%;
  min-height: clamp(420px, 56vh, 640px);
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  text-align: left;
  overflow: hidden;
}

.hero-photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 38%;
  transform: scale(1.02);
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(18, 13, 17, 0.9) 0%, rgba(18, 13, 17, 0.7) 42%, rgba(18, 13, 17, 0.24) 100%),
    linear-gradient(0deg, rgba(226, 34, 137, 0.26) 0%, rgba(226, 34, 137, 0) 42%);
}

.hero-content {
  position: relative;
  z-index: 1;
  width: min(100% - 40px, 1180px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.hero-title {
  margin: 0 0 8px 0;
  max-width: 760px;
  font-size: clamp(2.25rem, 6vw, 5.2rem);
  line-height: 0.96;
  color: #ffffff;
  font-weight: 800;
  text-wrap: balance;
  text-shadow: 0 18px 46px rgba(0, 0, 0, 0.55);
}

.hero-subtitle {
  width: min(100%, 560px);
  margin: 0;
  padding-top: 16px;
  border-top: 3px solid #e22289;
  font-size: clamp(1.12rem, 2vw, 1.45rem);
  line-height: 1.55;
  color: #fff7fb;
  text-shadow: 0 10px 28px rgba(0, 0, 0, 0.5);
}

.service-band {
  background:
    linear-gradient(180deg, #fff7fb 0%, #ffffff 88%),
    #ffffff;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding: 34px 20px 54px 20px;
}

.service-inner {
  width: min(100%, 1180px);
  margin: 0 auto;
}

.slogan-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.slogan-list li {
  position: relative;
  min-height: 112px;
  padding: 18px 16px 16px 18px;
  text-align: left;
  font-size: 1.02rem;
  line-height: 1.35;
  color: #211a20;
  background: #ffffff;
  border: 1px solid #f0bdd3;
  border-radius: 8px;
  box-shadow: 0 18px 36px rgba(42, 22, 34, 0.08);
  overflow: hidden;
}

.slogan-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 5px;
  background: #e22289;
}

@media (max-width: 768px) {
  .hero {
    min-height: 380px;
    align-items: center;
    text-align: left;
  }

  .hero-content {
    width: calc(100% - 28px);
    padding: 0;
  }

  .hero-title {
    max-width: 100%;
    font-size: clamp(2rem, 9vw, 3.1rem);
    line-height: 1.02;
    text-wrap: normal;
    overflow-wrap: break-word;
  }

  .hero-subtitle {
    font-size: 1.05rem;
  }

  .service-band {
    padding: 18px 10px 36px 10px;
  }

  .slogan-list {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .slogan-list li {
    min-height: auto;
    padding: 14px 14px 14px 16px;
    font-size: 1rem;
    line-height: 1.45;
  }
}

@media (min-width: 769px) {
  .hero-photo {
    object-position: 50% 24%;
    transform: none;
  }
}

@media (min-width: 769px) and (max-width: 1040px) {
  .slogan-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
